import {SportstypeSpec} from "../types";

import start from "../../icons/icehockey/start";
import end from "../../icons/icehockey/end";
import bully from "../../icons/icehockey/bully";
import goal from  "../../icons/icehockey/goal";
import minutes2 from "../../icons/icehockey/minutes-2"
import minutes2plus2 from "../../icons/icehockey/minutes-2plus2"
import minutes5 from "../../icons/icehockey/minutes-5"
import minutes10 from "../../icons/icehockey/minutes-10"
import minutes20 from "../../icons/icehockey/minutes-20"
import penalty from "../../icons/icehockey/penalty"
import main from "../../icons/icehockey/main";
import resumePeriods from "../../icons/icehockey/resume-periods";
import endOfRegularPlay from "../../icons/icehockey/end-of-regular-play";
import startOvertime from "../../icons/icehockey/start-overtime";
import pauseOvertime from "../../icons/icehockey/pause-overtime";
import resumeOvertime from "../../icons/icehockey/resume-overtime";
import endOfOvertime from "../../icons/icehockey/end-of-overtime";
import startShootout from "../../icons/icehockey/start-shootout";
import pausePeriods from "../../icons/icehockey/pause-periods";
import timeout from  "../../icons/icehockey/timeout";
import { initializeTeamGameScoreboard, scoreChange } from "../eventHandlerUtils";

const icehockey: SportstypeSpec = {
  id: 'icehockey',
  scoreboardType: 'team-game-scoreboard',
  svg: main,
  releaseStage: 'released',
  defaultTiming: {
    _type: "Tik::Model::Options::TimedGameOptions",
    num_regular_phases: 3,
    num_overtime_phases: 1,
    timing_type: "d",
    regular_phase_length: 20,
    overtime_phase_length: 5
  },
  displayTimeFormat: "M:ss",
  displayPhaseFormat: "long",
  displayPhaseOvertimeFormat: "overtime",
  events: [
    {
      id: 'goal',
      important: true,
      svg: goal,
      team: 'any',
      eventHandler: scoreChange(1),
      players: [
        {
          id: 'scorer',
          from: 'selected-team'
        },
        {
          id: 'assist',
          from: 'selected-team',
          max: 2
        }
      ]
    },
    {
      id: 'bully',
      important: true,
      team: 'any',
      svg: bully
    },
    {
      id: 'timeout',
      important: true,
      svg: timeout,
      team: 'any'
    },
    // {
    //   id: 'injury',
    //   important: true,
    //   svg: injury,
    //   team: 'any',
    //   players: [
    //     {
    //       id: 'injured',
    //       from: 'selected-team'
    //     }
    //   ]
    // },
    {
      id: 'penalty',
      important: true,
      svg: penalty,
      team: 'any',
      players: [
        {
          id: 'shooter',
          from: 'selected-team'
        }
      ]
    },
    {
      id: 'penalties',
      important: true,
      svg: minutes2,
      team: 'any',
      players: [
        {
          id: 'offender',
          from: 'selected-team'
        }
      ]
    },
    // {
    //   id: 'game-misconduct-penalty',
    //   important: true,
    //   svg: gameMisconductPenalty,
    //   team: 'any',
    //   players: [
    //     {
    //       id: 'offender',
    //       from: 'selected-team'
    //     }
    //   ]
    // },
    // {
    //   id: 'match-penalty',
    //   important: true,
    //   svg: matchPenalty,
    //   team: 'any',
    //   players: [
    //     {
    //       id: 'offender',
    //       from: 'selected-team'
    //     }
    //   ]
    // },
    {
      id: 'minutes-2plus2',
      important: true,
      svg: minutes2plus2,
      team: 'any',
      players: [
        {
          id: 'offender',
          from: 'selected-team'
        }
      ]
    },
    {
      id: 'minutes-5',
      important: true,
      svg: minutes5,
      team: 'any',
      players: [
        {
          id: 'offender',
          from: 'selected-team'
        }
      ]
    },
    // {
    //   id: 'minutes-5plus-game-misconduct-penalty',
    //   important: true,
    //   svg: minutes5plusGameMisconductPenalty,
    //   team: 'any',
    //   players: [
    //     {
    //       id: 'offender',
    //       from: 'selected-team'
    //     }
    //   ]
    // },
    {
      id: 'minutes-10',
      important: true,
      svg: minutes10,
      team: 'any',
      players: [
        {
          id: 'offender',
          from: 'selected-team'
        }
      ]
    },
    {
      id: 'minutes-20',
      important: true,
      svg: minutes20,
      team: 'any',
      players: [
        {
          id: 'offender',
          from: 'selected-team'
        }
      ]
    },
    // {
    //   id: 'minutes-2plus10',
    //   important: true,
    //   svg: minutes2plus10,
    //   team: 'any',
    //   players: [
    //     {
    //       id: 'offender',
    //       from: 'selected-team'
    //     }
    //   ]
    // },
    // {
    //   id: 'minutes-2plus2plus10',
    //   important: true,
    //   svg: minutes2plus2plus10,
    //   team: 'any',
    //   players: [
    //     {
    //       id: 'offender',
    //       from: 'selected-team'
    //     }
    //   ]
    // },
    // {
    //   id: 'opportunity',
    //   important: true,
    //   svg: opportunity,
    //   team: 'any',
    //   players: [
    //     {
    //       id: 'shooter',
    //       from: 'selected-team'
    //     },
    //     {
    //       id: 'keeper',
    //       from: 'other-team'
    //     }
    //   ]
    // },
    // {
    //   id: 'penalty-missed',
    //   important: true,
    //   svg: penaltyMissed,
    //   team: 'any',
    //   players: [
    //     {
    //       id: 'shooter',
    //       from: 'selected-team'
    //     },
    //     {
    //       id: 'keeper',
    //       from: 'other-team'
    //     }
    //   ]
    // },
    // {
    //   id: 'video-review',
    //   important: true,
    //   svg: videoReview
    // },
    // {
    //   id: 'video-review-confirmed',
    //   important: true,
    //   svg: videoReviewConfirmed
    // },
    // {
    //   id: 'video-review-overturned',
    //   important: true,
    //   svg: videoReviewOverturned
    // },
    {
      id: 'start',
      important: false,
      svg: start,
      eventHandler: initializeTeamGameScoreboard
    },
    {
      id: 'pause-periods',
      important: false,
      svg: pausePeriods
    },
    {
      id: 'resume-periods',
      important: false,
      svg: resumePeriods
    },
    {
      id: 'end-of-regular-play',
      important: false,
      svg: endOfRegularPlay
    },
    {
      id: 'start-overtime',
      important: false,
      svg: startOvertime
    },
    {
      id: 'pause-overtime',
      important: false,
      svg: pauseOvertime
    },
    {
      id: 'resume-overtime',
      important: false,
      svg: resumeOvertime
    },
    {
      id: 'end-of-overtime',
      important: false,
      svg: endOfOvertime
    },
    {
      id: 'start-shootout',
      important: false,
      svg: startShootout
    },
    {
      id: 'end',
      important: false,
      svg: end
    },
  ],
  legacyEventMap: {
    20: 'bully',
    30: 'timeout',
    // 40: 'Injury',
    100: 'goal',
    202: 'penalties',
    203: 'penalties',
    212: 'penalties',
    214: 'minutes-2plus2',
    215: 'minutes-5',
    216: 'penalties',
    220: 'minutes-10',
    223: 'penalties',
    224: 'penalties',
    228: 'minutes-20',
    250: 'penalty',
    // 260: 'opportunity',
    // 280: 'missed',
    // 285: 'review'
    // 286: 'review-confirmed'
    // 287: 'review-overturned'
  }
}

export default icehockey
